module.exports = __webpack_public_path__ + "static/media/Asset 36.200104bf.png";